import { render, staticRenderFns } from "./index1-4.vue?vue&type=template&id=67538ef8&scoped=true&"
import script from "./index1-4.vue?vue&type=script&lang=js&"
export * from "./index1-4.vue?vue&type=script&lang=js&"
import style0 from "./index1-4.vue?vue&type=style&index=0&id=67538ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67538ef8",
  null
  
)

export default component.exports